import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from './core/service/auth.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'xlab-web';

  constructor(
    private translateService: TranslateService,
    private authenticationService: AuthenticationService,
  ) {

    const localLang = localStorage.getItem('lang');
    if (localLang) {
      this.translateService.use(localLang);
    } else {
      const browserLang = this.translateService.getBrowserLang();
      this.translateService.use(browserLang || 'en');
    }
  }
}
